"use client"

import { useState, useEffect, useRef } from "react"
import styled from "styled-components"
import { Settings } from "react-feather"
import Card from "../ui/Card"

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const Title = styled.h3`
  font-size: 14px;
  font-weight: 500;
`

const SettingsButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 4px;
  border: none;
  background-color: transparent;
  color: ${(props) => props.theme.text};
  cursor: pointer;
  
  &:hover {
    background-color: ${(props) => props.theme.accent};
  }
`

const ScrollContainer = styled.div`
  height: 300px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const LiquidationCard = styled(Card)`
  padding: 12px;
`

const LiquidationContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const LiquidationInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const LiquidationType = styled.div`
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  background-color: ${(props) => (props.type === "long" ? `${props.theme.error}1a` : `${props.theme.success}1a`)};
  color: ${(props) => (props.type === "long" ? props.theme.error : props.theme.success)};
`

const LiquidationDetails = styled.div`
  display: flex;
  flex-direction: column;
`

const AssetName = styled.span`
  font-size: 14px;
  font-weight: 500;
`

const Timestamp = styled.span`
  font-size: 12px;
  color: ${(props) => props.theme.secondaryText};
`

const LiquidationValue = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`

const UsdValue = styled.div`
  font-size: 14px;
  font-weight: 500;
`

const AssetAmount = styled.div`
  font-size: 12px;
  color: ${(props) => props.theme.secondaryText};
`

function WhaleLiquidations() {
  const [liquidations, setLiquidations] = useState([])
  const scrollRef = useRef(null)

  // Simulate fetching liquidation data
  useEffect(() => {
    // Initial data
    const initialData = [
      {
        id: "1",
        type: "long",
        asset: "BTC",
        timestamp: new Date(Date.now() - 120000),
        amount: 2.5,
        usdValue: 108141.95,
      },
      {
        id: "2",
        type: "short",
        asset: "ETH",
        timestamp: new Date(Date.now() - 300000),
        amount: 45.2,
        usdValue: 105936.16,
      },
      {
        id: "3",
        type: "long",
        asset: "BTC",
        timestamp: new Date(Date.now() - 600000),
        amount: 1.8,
        usdValue: 77862.2,
      },
    ]

    setLiquidations(initialData)

    // Simulate new liquidations coming in
    const interval = setInterval(() => {
      const newLiquidation = {
        id: Date.now().toString(),
        type: Math.random() > 0.5 ? "long" : "short",
        asset: Math.random() > 0.3 ? "BTC" : "ETH",
        timestamp: new Date(),
        amount: Math.random() * 5,
        usdValue: Math.random() * 200000,
      }

      setLiquidations((prev) => [newLiquidation, ...prev.slice(0, 9)])
    }, 15000)

    return () => clearInterval(interval)
  }, [])

  // Auto-scroll to the top when new liquidations come in
  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = 0
    }
  }, [liquidations])

  return (
    <Container>
      <Header>
        <Title>Whale Liquidations</Title>
        <SettingsButton>
          <Settings size={16} />
        </SettingsButton>
      </Header>

      <ScrollContainer ref={scrollRef}>
        {liquidations.map((liquidation) => (
          <LiquidationCard key={liquidation.id}>
            <LiquidationContent>
              <LiquidationInfo>
                <LiquidationType type={liquidation.type}>
                  {liquidation.type === "long" ? "LONG" : "SHORT"}
                </LiquidationType>
                <LiquidationDetails>
                  <AssetName>{liquidation.asset}</AssetName>
                  <Timestamp>{liquidation.timestamp.toLocaleTimeString()}</Timestamp>
                </LiquidationDetails>
              </LiquidationInfo>
              <LiquidationValue>
                <UsdValue>${liquidation.usdValue.toLocaleString(undefined, { maximumFractionDigits: 0 })}</UsdValue>
                <AssetAmount>
                  {liquidation.amount.toFixed(2)} {liquidation.asset}
                </AssetAmount>
              </LiquidationValue>
            </LiquidationContent>
          </LiquidationCard>
        ))}
      </ScrollContainer>
    </Container>
  )
}

export default WhaleLiquidations

